// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oCSG","index":"styles_index__TTvW4"};